import React from 'react';
import { Button, Input, Card, Select, Radio, Upload, Tree, message, TreeSelect, Form } from 'antd';
import common from '../../assets/common.js';
import upload from '../../images/upload.svg';
import demo from '../../assets/data-demo.xls';
import './index.css';

const FormItem = Form.Item;
const Option = Select.Option;
const SHOW_PARENT = TreeSelect.SHOW_PARENT;
const { TreeNode } = Tree;

class Edit extends React.Component {
  constructor(props){
    super(props);
    this.state = {
      treeData: [],
      dept: [],
      file: "",
      value: [],
      type: !this.props.type?"people":"excel",
      loading: false,
      example: [],
      children: [],
      cardType: '全部',
      choosed: [],
      add: !this.props.type
    }
  }
  componentWillMount(){
    this.getArea();
    this.getDept();
    if( sessionStorage.getItem("subAdmin") !== "true" ){
      this.getType();
    }
  }
  // 获取电子校园卡类型已选区域
  getDept = (value) => {
    var postData = {};
    postData["_url"] = "api/dc/access/area";
    postData["cardTypeId"] = value;
    postData["_method"] = "GET";
    common.request(postData, this, function(obj, data) {
    },function(obj, data) {
      message.warning(data.message);
    });
  }
  // 查询部门信息
  getDept = () => {
    var postData = {};
    postData["_url"] = "api/ecard/dept";
    postData["_method"] = "GET";
    common.request(postData, this, function(obj, data) {
      obj.setState({
        dept: [data.result],
        defaultExpandedKeys: [data.result.deptId],
        firstDept: data.result.deptId
      })
      // console.log(data.result.deptId);
    },function(obj, data) {
      message.warning(data.message);
    });
  }
  getArea = () => {
    // console.log(this.state.cardType);
    let this_ = this;
    var postData = {};
    var choosed = [];
    if(sessionStorage.getItem("subAdmin") === "true") {
      postData["_url"] = "api/admin/area";
    } else {
      postData["_url"] = "api/dc/access/area";
      if(this_.state.cardType !== "全部") {
        postData["cardTypeId"] = this_.state.cardType;
      }
    }
    postData["_method"] = "GET";
    common.request(postData, this, function(obj, data) {
      let ar = data.result.subList.map(function(index){
        let arr1 = [];
        if(index.dcBuildingList.length !== 0) {
          let ar2 = index.dcBuildingList.map(function(item) {
            let arr2 = {};
            if(item.roomList.length !== 0) {
              let ar3 = item.roomList.map(function(dataItem) {
                let arr3 = {};
                arr3["title"] = dataItem.roomName;
                arr3["key"] = "roomId" + dataItem.roomId;
                arr3["id"] = dataItem.roomId;
                arr3["value"] = "roomId" + dataItem.roomId;
                arr3["dept"] = 3;
                if(dataItem.choice) {
                  choosed.push("roomId" + dataItem.roomId);
                }
                let example = this_.state.example;
                example.push(arr3)
                this_.setState({
                  example
                })
                return arr3;
              })
              arr2["children"] = ar3;
            }
            arr2["title"] = item.building;
            arr2["key"] = "buildingId" + item.buildingId;
            arr2["id"] = item.buildingId;
            arr2["value"] = "buildingId" + item.buildingId;
            arr2["dept"] = 2;
            if(item.choice) {
              choosed.push("buildingId" + item.buildingId);
            }
            let example = this_.state.example;
            example.push(arr2)
            this_.setState({
              example
            })
            return arr2;
          });
          arr1["children"] = ar2;
        }
        arr1["title"] = index.areaName;
        arr1["key"] = "areaId" + index.areaId;
        arr1["id"] = index.areaId;
        arr1["value"] = "areaId" + index.areaId;
        arr1["dept"] = 1;
        if(index.choice) {
          choosed.push("areaId" + index.areaId);
        }
        let example = this_.state.example;
        example.push(arr1)
        this_.setState({
          example
        })
        return arr1;
      });
      // console.log(this_.state.example);
      obj.setState({
        treeData: ar,
        choosed
      })
    }, function(obj, state) {

    })
  }
  onChangeTree = (value) => {
    // console.log(value);
    this.setState({ value });
  }
  cardType = (value) => {
    var that = this;
    this.setState({
      cardType: value,
      value: [],
      example: []
    },() => {
      that.getArea();
    })

  }
  handleFormLayoutChange = (e) => {
    // let this_ = this;
    this.setState({
      type: e.target.value
    })
    if(e.target.value === "ecard") {
      // this_.getDept();
    }
  }
  handleChange = (info) => {
    // console.log(info);
    if (info.file.status === 'done') {
      // getBase64(info.file.originFileObj, orgLogo => this.setState({ orgLogo }));
      console.log(info);
      this.setState({
        file: info.fileList[info.fileList.length - 1].response.result
      });
    }
  }
  onExpand = (expandedKeys) => {
    // console.log('onExpand', expandedKeys);
    this.setState({
      expandedKeys,
      autoExpandParent: false,
    });
  }

  onCheck = (checkedKeys, info) => {
    console.log('info', info);
    console.log('onCheck', checkedKeys);
    this.setState({ checkedKeys });
  }

  onSelect = (selectedKeys, info) => {
    // console.log("onSelect:" + selectedKeys);
    this.setState({ selectedKeys:selectedKeys[0] });
    if(this.state.firstDept === selectedKeys[0]) {
      // this.getUser(1);
    } else {
      // this.getUser(1,selectedKeys[0]);
    }
  }
  renderTreeNodes = data => data.map((item) => {
    if (item.subList) {
      return (
        <TreeNode title={item.deptName} key={item.deptId} dataRef={item}>
          {this.renderTreeNodes(item.subList)}
        </TreeNode>
      );
    }
    return <TreeNode {...item} />;
  })
  handleSubmit = (e) => {
    let this_ = this;
    e.preventDefault();
    this.props.form.validateFields((err, values) => {
      if (!err) {
        let roomIds = [];
        let buildings = [];
        let areaIds = [];
        this_.state.example.map((item) => {
          if(values["area"].indexOf(item.value) > -1) {
            if(item.dept === 3) {
              roomIds.push(item.id);
              values["roomIds"] = roomIds;
            } else if(item.dept === 2){
              buildings.push(item.id);
              values["buildingIds"] = buildings;
            } else {
              areaIds.push(item.id);
              values["areaIds"] = areaIds;
            }
          }
        })
        delete values["area"];
        delete values["type"];
        if( this.state.cardType !== "全部"){
          // console.log(values);
          this_.type(values);
        } else if(this_.state.type === "people") {
          delete values["cardTypeId"];
          // console.log(values);
          this_.user(values);
        } else if(this_.state.type === "excel") {
          delete values["excel"];
          delete values["cardTypeId"];
          values["file"] = this_.state.file;
          // console.log(values);
          this_.excel(values);
        } else {
          delete values["dept"];
          delete values["cardTypeId"];
          let depTags = this_.state.checkedKeys.sort();
          let arr = JSON.parse(JSON.stringify(this_.state.checkedKeys.sort()))
          for (let i = 0; i < arr.length; i++) {
            for (let j = i + 1; j < arr.length; j++) {
              if (arr[j].indexOf(arr[i]) > -1) {
                 depTags = depTags.filter(item => {
                   return item !== arr[j]
                 })
              }
            }
          }
          values["deptIds"] = depTags;
          console.log(values);
          this_.ecard(values);
        }
      }
    });
  }
  // 按校园卡类型下发权限
  type = (value) => {
    var postData = value;
    postData["_url"] = "api/whitelist/servial/ecard/type/syn";
    if(this.state.add) {
      postData["isAdd"] = true;
    } else {
      postData["isAdd"] = false;
    }
    common.request(postData, this, function(obj, data){
      message.info(data.message);
      setTimeout(function() {
        window.location.reload();
      }, 2000);
    },function(obj, state){
      message.warning(state.message);
    });
  }
  // 单个用户下发
  user = (value) => {
    var postData = value;
    postData["_url"] = "api/whitelist/servial/user/syn";
    common.request(postData, this, function(obj, data){
      message.info(data.message);
      setTimeout(function() {
        window.location.reload();
      }, 2000);
    },function(obj, state){
      message.warning(state.message);
    });
  }
  // 获取电子校园卡类型
  getType = () => {
    var postData = {};
    var children = [];
    var that = this;
    postData["_url"] = "api/ecard/types";
    postData["_method"] = "GET"
    common.request(postData, this, function(obj, data){
      for (let i = 0; i < data.result.length; i++) {
        if(i === 0) {
          children.push(<Option key={'all'} value={'全部'}>全部</Option>)
        }
        children.push(<Option key={data.result[i].cardTypeId} value={data.result[i].cardTypeId}>{data.result[i].cardTypeName}</Option>);
      }
      that.setState({
        children
      });
    },function(obj, state){
      message.warning(state.message);
    });
  }
  // 批量导入下发
  excel = (value) => {
    var postData = value;
    if(this.state.add) {
      postData["_url"] = "api/whitelist/servial/user/import/syn";
    } else {
      postData["_url"] = "api/whitelist/servial/user/import/delsyn";
    }
    common.request(postData, this, function(obj, data){
      message.info(data.message)
      setTimeout(function() {
        window.location.reload();
      }, 2000);
    },function(obj, state){
      message.info(state.message)
    });
  }
  // 电子校园卡批量下发
  ecard = (value) => {
    var postData = value;
    postData["_url"] = "api/whitelist/servial/user/ecard/dept/syn";
    common.request(postData, this, function(obj, data){
      message.info(data.message)
      setTimeout(function() {
        window.location.reload();
      }, 2000);
    },function(obj, state){
      message.info(state.message)
    });
  }
  onRemove = () => {
    this.setState({
      file:""
    })
  }
  downExcel = () => {
    window.location.href=demo;
  }
  render(){
    const { getFieldDecorator } = this.props.form;
    const { type, file, treeData, firstDept, dept, add, children, cardType, choosed } = this.state;
    // console.log(treeData);
    const tProps = {
      treeData: this.state.treeData,
      allowClear: true,
      value: this.state.value,
      onChange: this.onChangeTree,
      treeCheckable: true,
      showCheckedStrategy: SHOW_PARENT,
      searchPlaceholder: '请选择区域',
      style: {
        width: 300
      },
    };
    // console.log(tProps)
    const formItemLayout = {
      labelCol: {xs: { span: 12 },sm: { span: 3 },},
      wrapperCol: {xs: { span: 24 },sm: { span: 14 },},
    };
    const tailFormItemLayout = {
      wrapperCol: {
        xs: {
          span: 24,
          offset: 0,
        },
        sm: {
          span: 16,
          offset: 8,
        },
      },
    };
    return(
      <Card title={add?"新增权限":"删除权限"}>
        <Form onSubmit={this.handleSubmit}>
          {
            sessionStorage.getItem("subAdmin") !== "true" && <FormItem
              {...formItemLayout}
              label="选择卡类型"
            >
              {getFieldDecorator('cardTypeId', {
                rules: [{
                  required: true, message: '请选择卡类型!',
                }],
                initialValue: '全部'
              })(
                <Select style={{ width: 300 }} onChange={ this.cardType }>
                  {children}
                </Select>
              )}
            </FormItem>
          }
          <FormItem
            {...formItemLayout}
            label="选择区域"
          >
            {getFieldDecorator('area', {
              rules: [{
                required: true, message: '请选择区域!',
              }],
              initialValue: choosed
            })(
              <TreeSelect {...tProps} />
            )}
          </FormItem>
          {
            cardType === '全部' && <FormItem
              {...formItemLayout}
              label="添加方式"
            >
              {getFieldDecorator('type', {
                rules: [{
                  required: true, message: '请填写施工人员姓名!',
                }],
                initialValue: add? "people":"excel"
              })(
                <Radio.Group onChange={this.handleFormLayoutChange}>
                  { add && <Radio value="people">新增人员</Radio> }
                  <Radio value="excel">导入表格</Radio>
                  { add && <Radio value="ecard">电子校园卡信息导入</Radio> }
                </Radio.Group>
              )}
            </FormItem>
          }
          { type === "people" && cardType === '全部' &&  <div>
              <FormItem
                {...formItemLayout}
                label="姓名"
              >
                {getFieldDecorator('userName', {
                  rules: [{
                    required: true, message: '请填写姓名!',
                  }],
                })(
                  <Input placeholder="请填写姓名" />
                )}
              </FormItem>
              <FormItem
                {...formItemLayout}
                label="学号"
              >
                {getFieldDecorator('cardNo', {
                  rules: [{
                    required: true, message: '请填写学号!',
                  }],
                })(
                  <Input type="text" placeholder="请填写学号" />
                )}
              </FormItem>
              <FormItem
                {...formItemLayout}
                label="实体卡号"
              >
                {getFieldDecorator('plasticCardNumber', {
                  rules: [{
                    message: '请填写实体卡号!',
                  }],
                })(
                  <Input type="text" placeholder="请填写实体卡号"/>
                )}
              </FormItem>
              { this.props.form.getFieldValue('plasticCardNumber') && <FormItem
                  {...formItemLayout}
                  label="实体卡类别"
                >
                  {getFieldDecorator('plasticCardType', {
                    rules: [{
                      required: false, message: '请选择实体卡类别!',
                    }],
                    initialValue: 1
                  })(
                    <Select style={{ width: 180 }}>
                      <Option value={1}>身份证</Option>
                      <Option value={2}>Mifare_UltraLight</Option>
                      <Option value={3}>Mifare_One(S50)</Option>
                      <Option value={4}>Mifare_One(S70)</Option>
                      <Option value={5}>Mifare_Pro(X)</Option>
                      <Option value={6}>Mifare_DESFire</Option>
                      <Option value={238}>其他</Option>
                    </Select>
                  )}
                </FormItem>
              }
              <FormItem
                {...formItemLayout}
                label="性别"
              >
                {getFieldDecorator('gender', {
                  rules: [{
                    required: true, message: '请选择性别!',
                  }],
                  initialValue: 1
                })(
                  <Select style={{ width: 120 }}>
                    <Option value={1}>男</Option>
                    <Option value={2}>女</Option>
                  </Select>
                )}
              </FormItem>
            </div>
          }
          { type === "excel" && cardType === '全部'&&  <div className="text-center">
            <FormItem
              {...formItemLayout}
              label="上传表格"
            >
              {getFieldDecorator('excel', {
                rules: [{
                  required: true,message: '请上传表格!',
                }],
              })(
                <div>
                  <Upload
                    action="api/upload/file"
                    name="file"
                    onChange={this.handleChange}
                    onRemove={this.onRemove}
                  >
                    { file === "" ?
                      <div className="upload-btn">
                        <img src={ upload } alt=""/>
                        <div className="mt-8">点击选择上传表格</div>
                      </div>:''
                    }

                  </Upload>
                  <label>下载模板:</label>
                  <a onClick={ this.downExcel }>门禁实体卡导入模板</a>
                </div>
                )}
              </FormItem>
            </div>
          }
          { type === "ecard" &&  cardType === '全部' && <div>
            <FormItem
              {...formItemLayout}
              label="部门"
            >
              {getFieldDecorator('dept', {
                rules: [{
                  message: '请选择部门!',
                }],
              })(
                <Tree
                  checkable
                  onExpand={this.onExpand}
                  defaultExpandParent={true}
                  defaultExpandedKeys={[firstDept]}
                  onCheck={this.onCheck}
                  checkedKeys={this.state.checkedKeys}
                  onSelect={this.onSelect}
                >
                  {this.renderTreeNodes(dept)}
                </Tree>
                )}
              </FormItem>
            </div>
          }
          <FormItem {...tailFormItemLayout}>
            <Button type="primary" htmlType="submit" className="mr-8">提交</Button>
            <Button onClick={ this.props.back }>返回</Button>
          </FormItem>
        </Form>
      </Card>
    )
  }
}
const EditFrom = Form.create()(Edit);
export default EditFrom;



// WEBPACK FOOTER //
// ./src/component/power/edit.js